module.exports = __webpack_public_path__ + "img/LogoMicroMarket-2d-completo.f52c6538.gif";